import { ReactText } from 'react'
import { capitalize } from 'utils'

interface CopyProps {
  opacityPercentage: string
  blendMode: string
  radius: ReactText
  smoothCorners?: boolean
}

const copy = ({
  opacityPercentage,
  blendMode,
  radius,
  smoothCorners,
}: CopyProps) => {
  const radiusCopyValue = radius
    ? `\nRadius: ${radius}${smoothCorners ? ' (Smooth Corners)' : ''}`
    : ''
  const blendModeCopyValue =
    blendMode.toLowerCase() !== 'normal' ? ` (${capitalize(blendMode)})` : ''
  return `Opacity: ${opacityPercentage}${blendModeCopyValue}${radiusCopyValue}`
}

export default copy
